import {
    isNewProductIntroductionItem,
    isSitePageItem,
    ResourceLibraryItem,
} from '../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';
import { PIMCORE_CONTENT_BASE_URL } from './Pimcore';
import {
    isAssetItem,
    isInternalLinkItem,
    isArticleItem,
    isNewsItem,
} from '../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';
import { LocaleCode } from './Locale';
import { ResourceLibraryItemType } from '../graphql/pimcore/modules/resourceLibrary/types/resourceLibraryItems';

const USE_GENERIC_RL_ITEM_ROUTE = true;

const buildItemRoute = ({ item, lang }: OpenResourceLibraryItemProps): string => {
    if (USE_GENERIC_RL_ITEM_ROUTE) {
        return buildRoute(item.id, undefined, lang);
    }
    return buildRoute(item.id, item.kind, lang);
};

export const buildRoute = (
    id: string,
    type?: ResourceLibraryItemType,
    lang?: LocaleCode
): string => {
    let route = `/SalesResources/ResourceLibrary/${type ? type : 'item'}/${id}`;
    if (lang) {
        route += `/${lang}`;
    }
    return route;
};

export interface OpenResourceLibraryItemProps {
    item: ResourceLibraryItem;
    lang?: LocaleCode;
}

export const getResourceLibraryItemOpenUrl = ({
    item,
    lang,
}: OpenResourceLibraryItemProps): string | null => {
    if (isInternalLinkItem(item)) {
        return item.route ? `/${item.route}`.replace('//', '/') : '';
    }
    if (isAssetItem(item)) {
        if (item.asset) {
            const asset = lang ? item.assetByLanguage[lang] : item.asset;
            const assetPath = asset ? asset.fullpath : item.asset.fullpath;
            let url = PIMCORE_CONTENT_BASE_URL + assetPath;
            if (item.asset.mimeType.includes('html')) {
                url = buildItemRoute({ item, lang });
            }
            return url;
        }
    }
    if (
        isArticleItem(item) ||
        isNewsItem(item) ||
        isNewProductIntroductionItem(item) ||
        isSitePageItem(item)
    ) {
        return buildItemRoute({ item, lang });
    }
    return null;
};

export const openResourceLibraryItem = ({ item, lang }: OpenResourceLibraryItemProps) => {
    const url = getResourceLibraryItemOpenUrl({ item, lang });
    if (!url) {
        return;
    }
    if (isInternalLinkItem(item)) {
        window.location.href = url;
    }
    if (
        isAssetItem(item) ||
        isArticleItem(item) ||
        isNewsItem(item) ||
        isNewProductIntroductionItem(item) ||
        isSitePageItem(item)
    ) {
        window.open(url, '_blank');
    }
};
